import { useCallback, useEffect, useState } from 'react';
export const useMapboxSpriteData = (sprite) => {
    const [data, setData] = useState({ data: null, imageUrl: '' });
    //load spriteData - *.json
    const jsonFile = sprite ? new URL(`${sprite}.json`, window.location.href) : null;
    //load image *.svg
    const imageUrl = sprite ? `${sprite}.svg` : '';
    const fetchData = useCallback(async () => {
        if (!jsonFile)
            return;
        const headers = new Headers();
        const response = await fetch(jsonFile, {
            headers,
        });
        if (response.ok) {
            const data = await response.json();
            setData({ data, imageUrl });
        }
    }, [jsonFile]);
    useEffect(() => {
        fetchData();
    }, [sprite]);
    return data;
};
//# sourceMappingURL=useMapboxSpriteData.js.map